import React, { useState, useEffect, ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ME } from '../graphql/getMe';
import { useAuthenticated } from '../hooks/useAuthenticated';
import VerificationModal from './VerificationModal';
import FingerprintConfirmationModal from './FingerprintConfirmationModal';
import OnlyOneBrowserModal from './OnlyOneBrowserModal';

interface AuthVerificationProviderProps {
  children: ReactNode;
}

const AuthVerificationProvider: React.FC<AuthVerificationProviderProps> = ({
  children,
}) => {
  const {
    isAuthenticated,
    isVerified,
    hasFingerprint,
    isValidFingerprint,
    isAdmin,
  } = useAuthenticated();
  const { data: me } = useQuery(GET_ME);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showFingerprintModal, setShowFingerprintModal] = useState(false);
  const [showBrowserSessionModal, setShowBrowserSessionModal] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !isVerified) {
      setShowVerificationModal(true);
    }

    if (isAuthenticated && isVerified && !hasFingerprint && !isAdmin) {
      setShowFingerprintModal(true);
    }

    if (
      isAuthenticated &&
      isVerified &&
      hasFingerprint &&
      !isValidFingerprint &&
      !isAdmin
    ) {
      setShowBrowserSessionModal(true);
    }
  }, [
    isAuthenticated,
    isVerified,
    hasFingerprint,
    isValidFingerprint,
    isAdmin,
  ]);

  const handleVerificationSuccess = () => {
    setShowVerificationModal(false);
  };

  return (
    <>
      {children}

      {isAuthenticated && (
        <>
          <VerificationModal
            open={showVerificationModal}
            onClose={() => setShowVerificationModal(false)}
            email={me?.getMe?.email || ''}
            onVerificationSuccess={handleVerificationSuccess}
          />
          <FingerprintConfirmationModal
            open={showFingerprintModal}
            onClose={() => setShowFingerprintModal(false)}
          />
          <OnlyOneBrowserModal open={showBrowserSessionModal} />
        </>
      )}
    </>
  );
};

export default AuthVerificationProvider;
